import axios, { AxiosResponse } from "axios";
import { HideSpinner, ShowSpinner } from "../components/spinner";
import { ShowPopupError } from "../components/error-popup";

let isLoggedIn = false;
const addToShoppingListButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".shoppinglistAdd");
const shoppingListCountElements: NodeListOf<HTMLElement> = document.querySelectorAll(".shoppinglist__indicator");
const removeFromShoppingListButtons: NodeListOf<HTMLElement> = document.querySelectorAll(".shoppingListRemove");

/**
 * Fügt ein Produkt zur Merkliste hinzu
 * @param productId Die ID des Produkts
 */
const addToShoppingList = async (productId: string): Promise<void> => {
	ShowSpinner();
	try {
		const response: AxiosResponse = await axios.post("/umbraco/api/ShoppingListApi/Add", productId, {
			headers: {
				"Content-Type": "application/json"
			}
		});

		if (response.status === 200) {
			HideSpinner();
			await ShoppingListItemCount();
		} else {
			ShowPopupError("Fehler beim hinzufügen zur Merkliste");
			HideSpinner();
		}
	} catch (error) {
		HideSpinner();
		ShowPopupError("Fehler beim hinzufügen zur Merkliste");
	}
};

/**
 * Entfernt ein Produkt aus der Merkliste
 * @param productId Die ID des Produkts
 */
const removeFromShoppingList = async (productId: string, element: HTMLElement): Promise<void> => {
	ShowSpinner();
	try {
		const response: AxiosResponse = await axios.post("/umbraco/api/ShoppingListApi/Delete", productId, {
			headers: {
				"Content-Type": "application/json"
			}
		});

		if (response.status === 200) {
			HideSpinner();

			const productElement = element.closest(".event__item");
			if (productElement) {
				productElement.remove();
			}
			await ShoppingListItemCount();
		} else {
			ShowPopupError("Fehler beim Entfernen aus der Merkliste");
			HideSpinner();
		}
	} catch (error) {
		HideSpinner();
		ShowPopupError("Fehler beim Entfernen aus der Merkliste");
	}
};

/**
 * Leitet zur Login-Seite weiter
 * @param productId Die ID des Produkts für die Merkliste
 */
const redirectToLogin = (productId?: string): void => {
	const loginUrl = productId ? `/login?shoppinglistid=${productId}` : "/login";
	window.location.href = loginUrl;
};

/**
 * Lädt die Anzahl der Produkte in der Merkliste und aktualisiert die Anzeige
 */
export const ShoppingListItemCount = async (): Promise<void> => {
	isLoggedIn = document.body.getAttribute("data-auth") === "True";

	if (isLoggedIn === false || shoppingListCountElements.length === 0) {
		shoppingListCountElements.forEach((countEl) => {
			countEl.style.display = "none";
		});
		return;
	}

	try {
		const result: AxiosResponse<number> = await axios.get<number>(
			`/umbraco/api/ShoppingListApi/GetShoppingListItemsCount`
		);

		if (result.data > 0) {
			shoppingListCountElements.forEach((countEl) => {
				countEl.innerHTML = result.data.toString();
			});
		} else {
			shoppingListCountElements.forEach((countEl) => {
				countEl.style.display = "none";
			});
		}
	} catch (error) {}
};

export const handleAddToShoppingListClick = (button: HTMLElement): void => {
	isLoggedIn = document.body.getAttribute("data-auth") === "True";
	const itemId = button.getAttribute("data-productid");

	if (isLoggedIn && itemId) {
		addToShoppingList(itemId);
	} else {
		redirectToLogin(itemId);
	}
};

export const InitShoppingListLinks = () => {
	addToShoppingListButtons.forEach((button) => {
		button.addEventListener("click", () => {
			handleAddToShoppingListClick(button);
		});
	});

	removeFromShoppingListButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();
			const productId = button.getAttribute("data-productid");
			if (productId) {
				removeFromShoppingList(productId, button);
			}
		});
	});
};
